import { render, staticRenderFns } from "./ClamRepayTable.vue?vue&type=template&id=2e989ac6&"
import script from "./ClamRepayTable.vue?vue&type=script&lang=js&"
export * from "./ClamRepayTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports